/**
 * @generated SignedSource<<5423abd007829ff5392daa829a5498a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storyPackageQuery$data = {
  readonly storyPackageArticles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "homeStoryPackageLeadContentItemContent" | "homeStoryPackageTailContentItemContent">;
        };
      }>;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"hooksHomeStoryPackageTopicQueue">;
  } | null | undefined;
  readonly " $fragmentType": "storyPackageQuery";
};
export type storyPackageQuery$key = {
  readonly " $data"?: storyPackageQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyPackageQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "storyPackageArticlesQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "storyPackageQuery",
  "selections": [
    {
      "alias": "storyPackageArticles",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "storyPackageArticlesQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "hooksHomeStoryPackageTopicQueue"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityId",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "entityLink"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "homeStoryPackageLeadContentItemContent"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "homeStoryPackageTailContentItemContent"
                        }
                      ],
                      "type": "Content",
                      "abstractKey": "__isContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:3)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5d79d6c303b597edbadedc66911d2426";

export default node;
